<template>
  <div class="formdata number_persons">
    <div class="header-container">
    <h3 id="number_persons_question">Wie viele Personen leben im Haushalt?</h3>
</div>
    <CustomRadioGroup
        :options="numberPersons"
        v-model="selectedAnswer"
        aria-labelledby="number_persons_question"
        :unique="numberPersonsQuestion"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'number_persons_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>



    <button class="button button_yellow right" v-if="selectedAnswer" @click="submit">Weiter</button>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useWorkflowStore} from '../../stores/workflow.js';
import CustomRadioGroup from "@/components/CustomRadioGroup.vue";
import {numberPersons, numberPersonsApi} from "@/data/numberPersons";

const workflowStore = useWorkflowStore();


const getEventData = (selectedValue) => {
  const fullAnswer = numberPersons.find(bt => bt.value === selectedValue);

  if (fullAnswer) {
    return {
      value: selectedValue,
      apiDefinition: numberPersonsApi,
      apiValue: fullAnswer.api,
      available: fullAnswer.available
    };
  }
  return null;
};


const selectedAnswer = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.number_persons || null;
  },
  set(newValue) {
    // Der Setter wird aufgerufen, sobald der Benutzer einen Radio-Button auswählt.
    // Hier senden wir ein Event, das den Wert sofort im Store aktualisiert.
    const eventData = getEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_NUMBER_PERSONS_ANSWER',
      data: eventData,
    });
  }
});



const submit = () => {
  // Diese Funktion wird nur aufgerufen, wenn der "Weiter"-Button geklickt wird.
  // Der Wert ist bereits durch den Setter des computed properties im Store gespeichert.
  if (selectedAnswer.value) {
    const eventData = getEventData(selectedAnswer.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

<style scoped>




</style>